import React from 'react';
import './App.css';
import SnakeGame from './game/SnakeGame';

function App() {
  return (
    <div className="App">
      <SnakeGame />
    </div>
  );
}

export default App;
